import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('TellerKomponent');

/**
 * Viser rød ring med tall i
 */
@Component({
    selector: 'teller',
    templateUrl: 'teller.html',
    styleUrl: 'teller.scss',
    imports: [],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TellerKomponent {

    teller = input.required<number>();
    skjulTellerDersomNull = input(false, {transform: booleanAttribute});
    class = input('');

    visTeller = computed(() => this.skjulTellerDersomNull() ? this.teller() > 0 : true);

}
